import React, { Component } from 'react'
import { Button as NormalButton } from '@sainsburys-tech/bolt'
import PropTypes from 'prop-types'

import { useVocab } from '@sainsburys-tech/bolt-vocab-provider'

import ProductCareModalContainer from '../ProductCareModal/ProductCareModalContainer'
import FableAddToTrolleyButton from '../FableAddToTrolleyButton/FableAddToTrolleyButton'

import * as Styled from './AddToTrolleyButton.styles'
import { getAppExclusiveLink, isAppExclusiveSKU } from '@/javascript/helpers/appExclusiveSkusHelper'
import { BuyOnAppContainer } from '@/components/BuyOnApp/BuyOnAppContainer'

const BRAND = process.env.BRAND || 'ARGOS'

class AddToTrolleyButton extends Component {
  constructor(props) {
    super(props)
    this.state = {
      productCareModalOpen: false
    }
  }

  triggerProductCareModal = () => {
    this.setState({ productCareModalOpen: !this.state.productCareModalOpen })
  }

  closeProductCareModal = () => {
    if (this.state.productCareModalOpen) {
      this.setState({ productCareModalOpen: false })
    }
  }

  onTuRequestSuccess = () => {
    window.dispatchEvent(new CustomEvent('cartupdate'))
  }

  render() {
    const { productCareModalOpen } = this.state
    const {
      showAddToTrolley,
      quantityProps,
      quantityCount,
      buttonProps,
      warrantyItem,
      categories = [],
      trolleyButtonTrackingParams
    } = this.props

    if (!showAddToTrolley) {
      return null
    }

    const extendedButtonProps = { ...buttonProps }

    if (isAppExclusiveSKU(extendedButtonProps.partNumber)) {
      return <BuyOnAppContainer className='ds-mt-3' link={getAppExclusiveLink(extendedButtonProps.partNumber)} />
    }

    const lastCategory = categories[categories.length - 1]
    const synapticaId = warrantyItem && lastCategory ? lastCategory.id : ''

    if (BRAND === 'TU') {
      extendedButtonProps.onTrolleyRequestSuccess = this.onTuRequestSuccess
    }

    return (
      <div className='xs-row add-to-trolley-main top-border' data-test='add-trolley-button-wrapper'>
        <div className='xs-4--none'>
          <Styled.QuantitySelector aria-label='Quantity selector' {...quantityProps} />
        </div>
        <div className='xs-8--none'>
          {warrantyItem ? (
            <ProductCareButton
              data-test='add-to-trolley-product-care-button'
              triggerProductCareModal={this.triggerProductCareModal}
            />
          ) : (
            <FableAddToTrolleyButton
              productId={extendedButtonProps.partNumber}
              quantity={quantityCount}
              trackingParams={trolleyButtonTrackingParams}
              {...extendedButtonProps}
            />
          )}
          {warrantyItem && (
            <ProductCareModalContainer
              data-test='add-to-trolley-product-care-modal'
              show={productCareModalOpen}
              hide={this.closeProductCareModal}
              synapticaId={synapticaId}
            />
          )}
        </div>
      </div>
    )
  }
}

AddToTrolleyButton.propTypes = {
  trolleyButtonTrackingParams: PropTypes.shape({}).isRequired
}

const ProductCareButton = ({ triggerProductCareModal }) => {
  const { ITEM_CONTAINER } = useVocab()
  return (
    <NormalButton
      full
      data-test='add-to-trolley-button-product-care'
      onClick={() => {
        triggerProductCareModal()
      }}
    >
      Add to {ITEM_CONTAINER}
    </NormalButton>
  )
}

export default AddToTrolleyButton
